import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  stats: null,
  totalScripts: null,
  totalViews: null,
  recentScripts: [],
  dailyViews: [],
  monthlyViews: [],
  topVideos: [],
  regionTraffic: [],
  demographics: [],
  channelInfo: null,
  lastFetchedDateRange: null,
  lastSelectedStartDate: null,
  lastSelectedEndDate: null,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    fetchDashboardStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchDashboardSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.stats = action.payload.data;
      state.totalScripts = action.payload.data?.totalScripts || null;
      state.totalViews = action.payload.data?.totalViews || null;
      state.recentScripts = action.payload.data?.recentScripts || [];
      state.dailyViews = action.payload.data?.dailyViews || [];
      state.monthlyViews = action.payload.data?.monthlyViews || [];
      state.topVideos = action.payload.data?.topVideos || [];
      state.regionTraffic = action.payload.data?.regionTraffic || [];
      state.demographics = action.payload.data?.demographics || [];
      state.channelInfo = action.payload.data?.channelInfo || null;
      state.lastFetchedDateRange = action.payload.dateRange;
      state.lastSelectedStartDate = action.payload.startDate;
      state.lastSelectedEndDate = action.payload.endDate;
    },
    fetchDashboardFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearDashboard: (state) => {
      state.loading = false;
      state.error = null;
      state.stats = null;
      state.totalScripts = null;
      state.totalViews = null;
      state.recentScripts = [];
      state.dailyViews = [];
      state.monthlyViews = [];
      state.topVideos = [];
      state.regionTraffic = [];
      state.demographics = [];
      state.channelInfo = null;
      state.lastFetchedDateRange = null;
      state.lastSelectedStartDate = null;
      state.lastSelectedEndDate = null;
    },
  },
});

export const {
  fetchDashboardStart,
  fetchDashboardSuccess,
  fetchDashboardFailure,
  clearDashboard,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;

